export default __webpack_public_path__ + "static/media/typeTractor.41b78bf2.41b78bf2.svg";